import lang from './lang';

// URL: https://api.voicebunny.com/genderAndAges
// Date: 2015-07-27

// Auto-generated, so eslint should be relaxed
/* eslint comma-dangle:0 */
const voiceBunnyGenderAge = [
  {
    code: 'childBoy',
    name: 'Male | Child'
  },
  {
    code: 'teenageBoy',
    name: 'Male | Teenage'
  },
  {
    code: 'youngAdultMale',
    name: 'Male | Young adult'
  },
  {
    code: 'middleAgeMale',
    name: 'Male | Middle age'
  },
  {
    code: 'seniorMale',
    name: 'Male | Senior'
  },
  {
    code: 'childGirl',
    name: 'Female | Child'
  },
  {
    code: 'teenageGirl',
    name: 'Female | Teenage'
  },
  {
    code: 'youngAdultFemale',
    name: 'Female | Young adult'
  },
  {
    code: 'middleAgeFemale',
    name: 'Female | Middle age'
  },
  {
    code: 'seniorFemale',
    name: 'Female | Senior'
  }
];

function buildVoices() {
  const voices = {};
  for (const item of voiceBunnyGenderAge) {
    voices[item.code] = lang(item.code, item.name);
  }
  return voices;
}
export default buildVoices();



// WEBPACK FOOTER //
// ./src/config/voices.js